export interface ItemsRow {
  itemId: number;
  itemName: string;
  itemDesc: string;
  height: number;
  width: number;
  thick: number;
  length: number;
  weight: number;
  itemType: string;
  remarks: string;
}

export interface ItemsForm {
  item: string;
  detailedDescription: string;
  height: string;
  width: string;
  length: string;
  thickness: string;
  weight: string;
  group: string;
  notes: string;
}

export enum FieldType {
  String = "string",
  Number = "number",
  Decimal = "decimal",
}

export const FieldValues: Record<keyof ItemsForm, FieldType> = {
  item: FieldType.String,
  detailedDescription: FieldType.String,
  height: FieldType.Number,
  width: FieldType.Number,
  length: FieldType.Number,
  thickness: FieldType.Decimal,
  weight: FieldType.Decimal,
  group: FieldType.String,
  notes: FieldType.String,
};

export interface ItemsListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: ItemsRow[];
}

export interface ItemsUpdate {
  id: number;
  itemName: string;
  itemDesc: string;
  height: number;
  width: number;
  thick: number;
  length: number;
  weight: number;
  itemType: string;
  remarks: string;
}

export interface ItemsDetailResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: ItemsRow;
}

export interface ItemsState {
  loading: boolean;
  saving: boolean;
  list: ItemsRow[];
  error: string | null;
  isAddModalOpen: boolean;
  form: ItemsForm;
  detail: ItemsRow | null;
  detailLoading: boolean;
  detailError: string | null;
}
